import { createGrid, forEachColumn, HEIGHT, getIndex } from '../utils';

export class SpriteMode {
  constructor({ sprite, animationData }) {
    if (Array.isArray(sprite[0])) {
      // animated
      this.animated = true;
      this.frame = 0;
      this.time = 0;
    }
    if (animationData) {
      this.animationData = animationData;
    }
    this.sprite = sprite;

    this.spriteOrderShuffled = createGrid().map((d, i) => i);
    shuffle(this.spriteOrderShuffled);
  }
  update(delta, { audioData, enter } = {}) {

    this.enter = enter;

    if (this.animated) {
      let tickLength = 120;
      if (this.animationData?.delay?.[this.frame]) {
        tickLength = this.animationData?.delay[this.frame] * tickLength;
      }
      let tick = false;
      this.time += delta;
      if (this.time > tickLength) {
        tick = true;
        this.time = this.time % tickLength;
      }

      if (tick) {
        this.frame += 1;
        if (this.frame > this.sprite.length - 1) {
          this.frame = 0;
        }
      }
    }
  }
  getData() {
    if (this.animated) {
      if (this.animationData?.color?.[this.frame]) {
        return [... this.sprite[this.frame]].map(d => d ? this.animationData.color[this.frame] : false);
      }
      return [... this.sprite[this.frame]]
    }
    if (this.enter) {
      const progress = this.enter * this.sprite.length;
      return [... this.sprite].map((d, i) => d && progress > this.spriteOrderShuffled[i])
    }
    return [... this.sprite];

  }
}

function shuffle(array) {
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}